import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

import { LiveAd } from './live-ad'

export const ReplaceAdStockRequest = z.object({
  liveAds: LiveAd.array(),
})

export type ReplaceAdStockRequest = z.infer<typeof ReplaceAdStockRequest>

export const ReplaceAdStockResponse = z.object({
  stockFingerprint: z.string(),
})

export type ReplaceAdStockResponse = z.infer<typeof ReplaceAdStockResponse>

export const replaceAdStockDeclaration = endpointDeclaration(ReplaceAdStockRequest, ReplaceAdStockResponse)
